export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6886.a2821859.jpg";